import '../css/index.scss';
import APlayer from './player';

/* global APLAYER_VERSION */
console.log(`${'\n'} %c Vite-APlayer v${APLAYER_VERSION} %c https://github.com/o0w0b/vite-aplayer ${'\n'}`, 'color: #fadfa3; background: #030307; padding:5px 0;', 'background: #fadfa3; padding:5px 0;');

export default APlayer;
